import { render } from "./SiteBrand.vue?vue&type=template&id=bac7d1ba&scoped=true"
import script from "./SiteBrand.vue?vue&type=script&lang=js"
export * from "./SiteBrand.vue?vue&type=script&lang=js"

import "./SiteBrand.vue?vue&type=style&index=0&id=bac7d1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac7d1ba"]])

export default __exports__